import React = require('react');
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import Toggle from "material-ui/Toggle";
import l10n = require('diy/util/l10n');

import {autoprefixer} from "diy/material-ui/autoprefixer";

import CollectionsIcon from 'material-ui/svg-icons/image/collections';
import AddCircleIcon from 'material-ui/svg-icons/content/add-circle';
import Slider from "material-ui/Slider";
import {ShadingSetting} from "../../state";

type FileManagerItem = __diy.FileManager.Item;
type FileManagerSourcesConfig = __diy.FileManager.SourcesConfig;

export interface ImageSelectorViewProps extends React.Props<ImageSelectorView> {
    imageUrl: string;
    parallaxAvailable: boolean;
    parallaxEnabled?: boolean;
    shading: ShadingSetting;
    onImageChange: (
        imageId: number,
        imageType: string,
        successCallback: () => void,
        errorCallback: () => void
    ) => void;
    onShadingChange: (shading: ShadingSetting) => void;
    onEditImageClicked(): void;
    onSelectImageClicked(): void;
    onParallaxToggle?(): void;
}
interface ImageSelectorViewState {
    shading: ShadingSetting;
}

export default class ImageSelectorView
extends React.Component<ImageSelectorViewProps, ImageSelectorViewState> {
    constructor(props: ImageSelectorViewProps) {
        super(props);
        this.state = {
            shading: props.shading
        };
    }

    componentWillReceiveProps(nextProps: ImageSelectorViewProps) {
        this.state = Object.assign({}, this.state, {
            shading: nextProps.shading
        });
    }

    getImageChangeCallback(type: string) {
        return (items: FileManagerItem[], succClb: () => void, errClb: () => void) => {
            this.props.onImageChange(items[0].getId(), type, succClb, errClb);
        };
    }

    selectImage() {
        let sources: FileManagerSourcesConfig = {
            storage: {
                batchSize: 10,
                callback: this.getImageChangeCallback('storage')
            },
            cms: {
                batchSize: 1,
                callback: this.getImageChangeCallback('cms')
            },
            bigstock: {
                batchSize: 1,
                callback: this.getImageChangeCallback('storage')
            },
            '123rf': {
                batchSize: 1,
                callback: this.getImageChangeCallback('storage')
            }
        };
        diy.editor.filemanager = new diy.editor.Filemanager({
            appName: 'filemanager',
            mode: 'selection',
            maxSelection: 1,
            alreadyExisting: 0,
            sources: sources,
            callback: (/*{
                errorItems: errorItems,
                successItems: successItems
            }*/) => {
                //do nothing
            }
        });
        this.props.onSelectImageClicked();
    }

    hasImage() {
        return this.props.imageUrl && this.props.imageUrl.length;
    }

    render() {
        return (
            <div style={{margin: '0 10px 10px 10px'}}>
                <div style={autoprefixer({
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative'
                })}>
                    {this.hasImage() ?
                        <div
                            onTouchTap={() => {this.selectImage();}}
                            style={autoprefixer({
                                backgroundImage: "url(" + this.props.imageUrl + ")",
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                height: 110,
                                cursor: 'pointer',
                                border: '1px solid rgba(117, 117, 117, 0.4)',
                                borderRadius: '2px',
                                boxSizing: 'border-box',
                                flexGrow: 1
                            })}
                            data-test-id="background-image-preview"
                        >
                            <div style={{backgroundColor: 'rgba(0, 0, 0, .45)', height: '100%'}}/>
                        </div> : null
                    }
                    {this.hasImage() ?
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: 0,
                                width: '100%',
                                padding: '10px',
                                boxSizing: 'border-box',
                                transform: 'translateY(-50%)'
                            }}
                        >
                            <IconTextButton
                                style={autoprefixer({
                                    marginTop: 10,
                                    flexGrow: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '50%'
                                })}
                                buttonStyle={{
                                    width: "100%"
                                }}
                                Icon={<CollectionsIcon/>}
                                text={l10n.getString('section.imageSelector.buttons.changeImage.label')}
                                onTouchTap={() => this.selectImage()}
                                dataTestId={"background-change-image"}
                                useLightColors={true}
                                isLabelWrapped={true}
                            />
                            <IconTextButton
                                style={autoprefixer({
                                    marginTop: 10,
                                    flexGrow: 1,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '50%'
                                })}
                                buttonStyle={{width: "100%"}}
                                Icon={<CollectionsIcon/>}
                                text={l10n.getString('section.imageSelector.buttons.editImage.label')}
                                onTouchTap={() => this.props.onEditImageClicked()}
                                dataTestId={"background-edit-image"}
                                useLightColors={true}
                                isLabelWrapped={true}
                            />
                        </div> :
                        <IconTextButton
                            style={autoprefixer({
                                marginTop: 10,
                                flexGrow: 1,
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: '2px dashed #e1e1e1',
                                display: 'flex',
                                height: 112
                            })}
                            Icon={<AddCircleIcon/>}
                            text={l10n.getString('section.imageSelector.buttons.selectImage.label')}
                            onTouchTap={() => this.selectImage()}
                            dataTestId={"background-select-image"}
                            useAlternativeColors={true}
                        />
                    }
                </div>
                {this.hasImage() && this.state.shading.enabled ?
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: 10,
                        borderBottom: this.props.parallaxAvailable ? '1px #ccc solid' : void 0
                    }}>
                        <div>
                            {l10n.getString('section.imageSelector.buttons.shading.label')} {this.state.shading.alpha}
                        </div>
                        <Slider
                            sliderStyle={{
                                marginTop: 10,
                                marginBottom: 10
                            }}
                            value={this.state.shading.alpha}
                            defaultValue={0.5}
                            step={0.05}
                            min={0.1}
                            max={0.9}
                            onChange={(e: React.FormEvent<{}>, value: number) => {
                                let newShading = Object.assign({}, this.state.shading, {
                                        alpha: value
                                    }
                                );
                                //keyboard
                                if (e.type === 'keydown') {
                                    this.props.onShadingChange(newShading);
                                } else {
                                    this.setState(Object.assign({}, this.state, {shading: newShading}));
                                }
                            }}
                            onDragStop={() => {
                                this.props.onShadingChange(this.state.shading);
                            }}
                        />
                    </div>
                    : null
                }
                {
                    this.hasImage() && this.props.parallaxAvailable ?
                        <div style={{
                            marginTop: 10
                        }}>
                            <Toggle
                                label={l10n.getString('section.imageSelector.parallax.label')}
                                toggled={this.props.parallaxEnabled}
                                onToggle={this.props.onParallaxToggle}
                            />
                        </div> :
                        null
                }
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/common/ImageSelectorView.tsx
 **/